import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as subcategory from '../subcategory'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subcategory.RESOURCE.payload.dimension.partialId,
      partialId: subcategory.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description: 'Is this an O&M subcategory that is related to utility costs?',
    isOptional: true,
    name: 'Is Utility Related?',
    partialId: PartialId.Standard.create('is_util'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
